import { useQuery } from '@tanstack/react-query';
import { hyperliquidThrottle } from '@/utils/requestThrottle';
import type { UniverseEntry, AssetContext } from '@/types';

interface MetaAndAssetCtxsResult {
  universe: UniverseEntry[];
  assetCtxs: AssetContext[];
}

export function useMetaAndAssetCtxs() {
  return useQuery<MetaAndAssetCtxsResult>({
    queryKey: ['metaAndAssetCtxs'],
    queryFn: async ({ signal }) => {
      const response = await hyperliquidThrottle.run(() =>
        fetch('https://api.hyperliquid.xyz/info', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ type: 'metaAndAssetCtxs' }),
          signal,
        }),
      );
      const data = await response.json();
      return {
        universe: data[0].universe,
        assetCtxs: data[1],
      };
    },
    staleTime: 60_000,
  });
}
